import React from "react";
import { financeDashboardData } from "../../data/financeMockData";

import SummaryRow from "../common/SummaryRow";

const PayrollSummary = () => {
    const payroll = financeDashboardData.payroll;
  return (
    <div className="dashboard-card">
      <div className="card-header">
        <h3 className="card-title">Payroll Summary</h3>

        <span className="card-badge">July 2026</span>
      </div>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "14px",
          marginTop: "10px",
        }}
      >
        <SummaryRow
  label="Employees Paid"
  value={payroll.employeesPaid}
/>
        <SummaryRow
  label="Pending Payroll"
  value={payroll.pendingPayroll}
/>
        <SummaryRow label="Next Payroll Date" value={payroll.nextPayrollDate} />
        <SummaryRow label="Status" value={payroll.status} />
      </div>
    </div>
  );
};


export default PayrollSummary;